<template>
    <tr v-if="projectItem" :style="projectItem.num > 2 ?'display:none' : ''">
        <td>
            <a href="#" class="prod">
                {{projectItem.name}}
            </a>
            <div class="tablet-stripe">
                <div>{{columns[1]}} {{projectItem.quantity}}</div>
                <div>{{columns[2]}} {{projectItem.retailPrice}}</div>
                <div v-if="this.selfSelect && projectItem.optPrice">
                  {{columns[3]}} <span v-html="projectItem.optPrice"></span>
                </div>
            </div>
        </td>
        <td>
            <input class="my_custom_input_product_quantity form-control project-item-quantity" v-model="quantity" type="number" min="0" v-on:change="changeQuantity(projectItem.id)">
        </td>
        <td>
          <span v-html="projectItem.retailPrice"></span>
        </td>
        <td>
          <span v-html="projectItem.optPrice"></span>
        </td>
        <td>
            <span v-html="projectItem.retailAznPrice"></span>
        </td>
        <td>
            <span class="mobile-label">{{columns[4]}}</span>
            <span v-html="projectItem.retailPriceSum"></span>
        </td>
        <td>
            <span class="mobile-label">{{columns[5]}}</span>
            <span v-html="projectItem.optPriceSum"></span>
        </td>
        <td>
            <span class="mobile-label">{{columns[4]}}</span>
            <span v-html="projectItem.retailAznPriceSum"></span>
        </td>
        <td>
            <a @click="removeProduct(projectItem)" href="javascript:;" class="remove">
                <i class="demo-icon icon-union-50"></i>
            </a>
        </td>
    </tr>
</template>

<script>
    import {mapGetters} from 'vuex';
    import ProjectItemQuantity from "vueComponents/project/ProjectItemQuantity";

    /**
     * Компонент для отображения товара на странице корзины
     *
     * @vuedoc
     * @module vue:components/ProjectItem
     * @exports vue:components/ProjectItem
     */
    export default {
        name: "project-item",

        props: [
            'projectItem', 'project_id', 'currency', 'selfSelect', 'photoSelect', 'columns'
        ],

        components: {
            'project-item-quantity': ProjectItemQuantity,
        },

        data() {
            return {
                productId: this.product_id,
                quantity: this.projectItem.quantity
            }
        },

        computed: {

            ...mapGetters('project', [
                'projectItems', 'projectPrice'
            ]),

            getProjectPhoto: function () {
                if (this.projectItems.photo) {
                    return this.projectItems.photo;
                }
                return false;
            },
        },

        mounted() {
        },


        methods: {

            /**
             * Удаляем товар из проекта пользователя
             *
             * @method removeProduct
             */
            removeProduct(item) {
                if (this.project_id)
                    this.$store.dispatch('project/removeProduct', {productId: item.id, projectId: this.project_id, selfSelect: this.selfSelect});
                else
                    console.log("no project name");
            },
            changeQuantity(id) {
                this.$store.dispatch('project/changeQuantity', {productId: id, projectId: this.project_id, quantity: this.quantity});
            }
        }
    }


</script>
